import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext';

const LocationSlideFour = () => {
    const {slideIndex} = useContext(AppContext);
    const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

  return (
    <div>
        <div className="location_info">

<div className="main_image slide_main_div"  >



    <div className="mt-4 content-main-image">
    <div className="d-flex-c f-sv f-wrap">
        <button className="btn_status_location">اطلب الان</button>
        <h1 className='location_slidetwo_headline' >خدماتنا السياحية في المكان  </h1>
        </div>
        
     <div className="mt-2 services_location_icons d-flex-c f-sv">

        <div className="single_serv_icon">
            <img src="/images/icons/photographer.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1"> نحجزلك مصور </h1>
        </div>

        <div className="single_serv_icon">
            <img src="/images/icons/hotel-icon.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1"> نحجزلك فندق </h1>
        </div>

     </div>
     <div className="services_location_icons d-flex-c f-sv">

        <div className="single_serv_icon">
            <img src="/images/icons/guide.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1"> نحجزلك مرشد سياحي</h1>
        </div>

        <div className="single_serv_icon">
            <img src="/images/icons/electric-car.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1"> نحجزلك سيارة </h1>
        </div>

     </div>

     <div className="f-sv d-flex-c sliding_btns mt-3">
              <button className="btn_category bg_red " onClick={() => setIndexSlideValue(indexSlideValue - 1) } > السابق </button>
                <button className="btn_category bg_green" onClick={() => setIndexSlideValue( indexSlideValue + 1) } > التالي </button>
              </div>

    </div>
    
</div>




</div>
    </div>
  )
}

export default LocationSlideFour